// extracted by mini-css-extract-plugin
module.exports = {"label":"formTextarea_label__2Ds-5","textarea":"formTextarea_textarea__pLI1u"};